const FourthSection = () => {
    return <div className="fourth-section">

        <div className="round-div">

            <div className="left-text">
                <p>

                    Deep immersion in challenges and the combination of expertise are the starting point for creating clear concepts,
                    real impact and consistent results. We collaborate with those who generate value in
                    a broad and deep way, forming long-term partnerships,
                    high-impact and high-yield businesses, and places that improve our future.
                </p>
                <div className="gradient"></div>
            </div>
            <div className="right-circle"></div>

        </div>

        <img src="beach.webp" />
        <div className="fifth-text">
            <p className="text-above-image">WE CREATE PROJECTS WITH VALUES</p>
        </div>

    </div>
}

export default FourthSection